import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { _ } from "src/services";
import { ConfigInit, Modals, ModalsAction } from "src/store";
import { Login } from "../svg";
import { Modal } from "./modal";

export const LoginPermissionModal: React.FC = () => {

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const config: ConfigInit = useSelector((state: any) => state.ConfigState);
    const history = useHistory();

    const onClose = () => dispatch(ModalsAction.hideLoginPermission());

    //#region helpers

    const loginOrRegister = (e?: React.MouseEvent<HTMLButtonElement>) => {
        onClose();
        e?.stopPropagation();
        e?.preventDefault();
        modals.from && history.push(modals.from);
    }

    const renderFooter = () => {
        return (
            <>
                <div className="col-6 col-md-5">
                    <button onClick={loginOrRegister} className="w-100 btn focusable btn-submit">{config.config.appSetting.promotion.submitBtn}</button>
                </div>
                <div className="col-6 col-md-5 offset-md-2">
                    <button onClick={onClose} className="w-100 btn btn-cancel">{config.config.appSetting.promotion.cancelBtn || _("cancel")}</button>
                </div>
            </>
        );
    };


    const renderBody = () => {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="profile-icon"> {config.config.appSetting.promotion.icon ? <img src={config.config.appSetting.promotion.icon} alt="login permission" /> : <Login />}</div>
                <p className="text-center rtl">{config.config.appSetting.promotion.message}</p>
            </div>
        );
    };

    //#end region

    return (
        <Modal title={config.config.appSetting.promotion.title} show={modals.loginPermission} onClose={onClose} renderFooter={renderFooter} className="modal-component--profile ltr">
            <div className="content text-right">
                {renderBody()}
            </div>
        </Modal>
    );

};